import React, { FC } from 'react';
import { View, StyleSheet } from 'react-native';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import NCLine from './NCLine';
import { NCToolCallHeaderProps } from '@components/common/NCFile/types';
import { NC_FILE_TOOL_CALL_HEADER_HEIGHT } from '@components/common/NCFile/constants/ncFileViewer.constants';

const NCToolCallHeader: FC<NCToolCallHeaderProps> = ({ C, line, paddingHorizontal, scale, ncFileTextColor, singleColor, ncFileContentFontConfig, isExpanded, onPress }) => {
  return (
    <TouchableElement onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            styles.container,
            {
              backgroundColor: C(pressHoverColor('Button/Light/Secondary')),
              minHeight: scale(NC_FILE_TOOL_CALL_HEADER_HEIGHT),
            },
          ]}
        >
          <NCLine
            C={C}
            line={line}
            paddingHorizontal={paddingHorizontal}
            scale={scale}
            ncFileTextColor={ncFileTextColor}
            singleColor={singleColor}
            ncFileContentFontConfig={ncFileContentFontConfig}
          />
          <View style={[styles.arrowContainer, { width: scale(42), height: scale(42) }]}>
            <View style={{ transform: [{ rotate: isExpanded ? '90deg' : '0deg' }] }}>
              <Svg icon="chevronRight" width={scale(9)} height={scale(15)} color="Button/Light/Primary" />
            </View>
          </View>
        </View>
      )}
    </TouchableElement>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  arrowContainer: {
    position: 'absolute',
    right: 0,
    top: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default React.memo(NCToolCallHeader, (prev, next) =>
  prev.line.key === next.line.key && prev.isExpanded === next.isExpanded && prev.C.scheme === next.C.scheme && prev.singleColor === next.singleColor && prev.ncFileTextColor === next.ncFileTextColor
);
